import { config } from "@noted/configuration";
import { useState } from "react";

import {
  Context,
  isDarkNotedUser,
  useCreateContextSessionMutation,
  UseCreateContextSessionMutationError,
  useGetContextsQuery,
} from "../../api/context-api";
import NoLinkedContextsCard from "./cards/no-linked-contexts-card";
import ContextList from "./context-list";

function determineMessage(error: UseCreateContextSessionMutationError) {
  if (error.code) {
    switch (error.code) {
      case "ctx-1001":
        return "A session already exists for this user. Please refresh the page and retry.";
      case "ctx-1002":
        return "The user cannot be found. Please contact an organisation administrator.";
      case "ctx-1003":
        return "This user is suspended and cannot be used. Please contact an organisation administrator.";
    }
  }

  return "Error selecting user. Please refresh the page and retry or contact Noted support.";
}

async function navigateToApp(context: Context, session?: string) {
  const url = isDarkNotedUser(context) ? config.darkNotedUrl : config.appUrl;
  const s = session ?? context.session;
  window.location.href = url + "?s=" + s;
}

function Contexts() {
  const { data } = useGetContextsQuery();
  const { mutate } = useCreateContextSessionMutation();
  const [isLoading, setIsLoading] = useState(false);

  const handleContextSelection = async (context: Context) => {
    if (context.session) {
      await navigateToApp(context);
      return;
    }

    setIsLoading(true);

    mutate(context.id, {
      onSuccess: session => navigateToApp(context, session),
      onError: error => {
        alert(determineMessage(error));
        setIsLoading(false);
      },
    });
  };

  if (data.length === 0) return <NoLinkedContextsCard />;
  return <ContextList contexts={data} onSelect={handleContextSelection} isLoading={isLoading} />;
}

export default Contexts;
